import { apiDelete, apiGet, apiPost } from '../_common';

const BASE = '/magenta/fulfillment/subscription-box-order-return';

export default {
  create(request) {
    return apiPost(BASE, request)
      .then(result => result.response);
  },

  search(query) {
    return apiGet(BASE, query).then(result => result.response);
  },

  find(id) {
    return apiGet(`${BASE}/${id}`).then(result => result.response);
  },

  findByBoxOrderId(boxOrderId) {
    return apiGet(`${BASE}/by-order/${boxOrderId}`).then(result => result.response);
  },

  // Retries whatever the return still has pending.
  process(id) {
    return apiPost(`${BASE}/${id}/process`, {}).then(result => result.response);
  },

  // Attaches an NFe that was issued by hand in Bling and resumes the remaining steps.
  registerReturnNFe(id, request) {
    return apiPost(`${BASE}/${id}/return-nfe`, request).then(result => result.response);
  },

  registerLossNFe(id, request) {
    return apiPost(`${BASE}/${id}/loss-nfe`, request).then(result => result.response);
  },

  remove(id) {
    return apiDelete(`${BASE}/${id}`).then(result => result.response);
  },

  statusTranslation: {
    NEW: 'Registrada',
    RETURN_NFE_CREATED: 'NF de devolução emitida',
    FINALIZED: 'Finalizada',
  },

  typeTranslation: {
    FAILED_DELIVERY: 'Caixa Completa',
    EXCHANGE: 'Caixa Parcial',
  },

  describeStatus(status) {
    return this.statusTranslation[status] || status;
  },

  describeType(type) {
    return this.typeTranslation[type] || type;
  },
};
